import React, { useMemo } from "react";
import _ from "lodash/fp";
import { Box, IconButton, Toolbar, Tooltip } from "@mui/material";
import {
  ArrowRight,
  ContentCopy,
  DeleteForever as DeleteIcon,
  AccountPlus as AddUserIcon,
  Close as CloseIcon,
} from "@actinc/dls/icons";

import { PreviewContent } from "../";

import { PREVIEW_TYPES } from "../../services/utils";

const IconToolbar = ({
  handleClone,
  handleDelete,
  handleMove,
  handleAssignUser,
  objectType,
  handleCloseTasks,
  permittedActions = [],
  selectedRows = [],
  ...props
}) => {
  const pluralizedObjectType = useMemo(
    () => `${objectType}${selectedRows.length > 1 ? "s" : ""}`,
    [objectType, selectedRows.length],
  );

  if (
    !_.intersection(permittedActions)([
      "clone",
      "delete",
      "move",
      "preview",
      "createAdditionalTasks",
      "closeTasks",
    ]).length
  )
    return null;

  return (
    <Toolbar>
      <Box>
        {permittedActions.includes("preview") && (
          <PreviewContent
            color="inherit"
            objects={selectedRows.map(({ id }) => ({
              id,
            }))}
            objectType={objectType}
            previewTypes={PREVIEW_TYPES}
          />
        )}
        {permittedActions.includes("delete") && (
          <Tooltip
            title={`Delete ${pluralizedObjectType}`}
            aria-label={`Delete ${pluralizedObjectType}`}
          >
            <IconButton
              aria-controls="delete"
              aria-label={`delete ${pluralizedObjectType}`}
              onClick={handleDelete}
              color="inherit"
              size="small"
              variant="text"
            >
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        )}
        {permittedActions.includes("move") && (
          <Tooltip title={`Move ${pluralizedObjectType}`}>
            <IconButton
              aria-controls="move"
              aria-label={`move ${pluralizedObjectType}`}
              onClick={handleMove}
              color="inherit"
              size="small"
            >
              <ArrowRight />
            </IconButton>
          </Tooltip>
        )}
        {permittedActions.includes("clone") && (
          <Tooltip title={`Clone ${pluralizedObjectType}`}>
            <IconButton
              aria-controls="clone"
              aria-label={`clone ${pluralizedObjectType}`}
              onClick={handleClone}
              color="inherit"
              size="small"
            >
              <ContentCopy />
            </IconButton>
          </Tooltip>
        )}
        {permittedActions.includes("createAdditionalTasks") && (
          <Tooltip title={`Assign ${pluralizedObjectType}`}>
            <IconButton
              aria-controls="Assign"
              aria-label={`Assign ${pluralizedObjectType}`}
              onClick={handleAssignUser}
              color="inherit"
              size="small"
              variant="text"
            >
              <AddUserIcon />
            </IconButton>
          </Tooltip>
        )}
        {permittedActions.includes("closeTasks") && (
          <Tooltip title={`Close ${pluralizedObjectType}`}>
            <IconButton
              aria-controls="Close"
              aria-label={`Close ${pluralizedObjectType}`}
              onClick={handleCloseTasks}
              color="inherit"
              size="small"
              variant="text"
            >
              <CloseIcon />
            </IconButton>
          </Tooltip>
        )}
      </Box>
    </Toolbar>
  );
};

export { IconToolbar };
